export default "/images/SaraRosésTerrón.jpg?fe1f13fb6712da988c31a66a46ad6348";